<template>
  <div class="membership_manage_width">
    <div class="pa-3 pl-10">
      <p class="display-1 mt-7">멤버십 설정/관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쿠팡,네이버,G마켓,옥션등 기타 마켓에서 제공하는 멤버십 서비스와 같이
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        우리 쇼핑몰만의 멤버십을 만들어 회원들에게 제공할 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정기결제의 경우 사용중인 PG사에 신청하여 사용이 가능합니다 . (올앳,
        이니시스, KCP, 토스페이먼츠 가능)
      </p>
    </div>
    <v-container class="pl-10">
      <v-tabs>
        <!--
            멤버십 혜택 설정 contents 영역
        -->
        <v-tab class="title">멤버십 혜택 설정</v-tab>
        <v-tab-item :eager="true">
          <MembershipReSetting></MembershipReSetting>
        </v-tab-item>

        <!--
           쇼핑몰 노출 부분 설정 contents 영역
        -->
        <v-tab class="title">쇼핑몰 노출 부분</v-tab>
        <v-tab-item :eager="true">
          <MallShowPartSetting></MallShowPartSetting>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import MembershipReSetting from "@/components/membership/membership_manage/MembershipReSetting.vue";
import MallShowPartSetting from "@/components/membership/membership_manage/MallShowPartSetting.vue";

export default {
  components: {
    MembershipReSetting,
    MallShowPartSetting,
  },
};
</script>
